import { createSlice } from "@reduxjs/toolkit";
import API_URLS from "../../apiConfig";


const initialState = {
    apiUrl: API_URLS.base,
};

const ApiUrlSlice = createSlice({
    name: "api",
    initialState,
    reducers: {
        setApiUrl(state, action) {
            state.apiUrl = action.payload;
            console.log("setApiUrl action called with payload:", action.payload);

        },
    },
});

export const { setApiUrl } = ApiUrlSlice.actions; // <--- corrected export
export default ApiUrlSlice.reducer;


